import BossModel from "@/models/BossModel";

export default class CachedProductPrice extends BossModel {

    /**
     *
     * @type {string}
     */
    static entity = 'cachedProductPrices';

    static fields() {
        return {
            id: this.attr(null),
            product_id: this.attr(null),
            product_detail_composition_id: this.attr(null),
            total_sale_price: this.attr(null),
            adults_amount: this.attr(null),
            children_amount: this.attr(null),
            babies_amount: this.attr(null),
            booking_date: this.attr(null),
            start_date: this.attr(null),
            end_date: this.attr(null),
            created_at: this.attr(null),
            sale_price_per_person: this.attr(null),
        }
    }
}
